import type { App } from 'vue';
import {
  Button,
  Input,
  Layout,
  Row,
  Col,
  Form,
  FormItem,
  Select,
  Table,
} from 'ant-design-vue';
const compList = [
  Button,
  Button.Group,
  Row,
  Col,
  Input,
  Input.TextArea,
  Form,
  FormItem,
  Select,
  Select.Option,
  Table,
];
export function registerGlobComp(app: App) {
  compList.forEach((comp) => {
    app.component(comp.name || comp.displayName, comp);
  });
  app.use(Layout);
}
